import { render, staticRenderFns } from "./RejectTicket.vue?vue&type=template&id=20c1291d&scoped=true"
import script from "./RejectTicket.vue?vue&type=script&lang=js"
export * from "./RejectTicket.vue?vue&type=script&lang=js"
import style0 from "./RejectTicket.vue?vue&type=style&index=0&id=20c1291d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1291d",
  null
  
)

export default component.exports